import {
	BREAKPOINT_L,
	BREAKPOINT_M,
	BREAKPOINT_S,
	BREAKPOINT_XL,
	BREAKPOINT_XS,
	BREAKPOINT_XXL,
} from '@audi/audi-ui-design-tokens';

export type BreakPoints = {
	'0'?: string;
	'375'?: string;
	'768'?: string;
	'1024'?: string;
	'1440'?: string;
	'1920'?: string;
};

export const mobileBreakPoint = 1440;

export const breakPointTokens = {
	'0': BREAKPOINT_XS,
	'375': BREAKPOINT_S,
	'768': BREAKPOINT_M,
	'1024': BREAKPOINT_L,
	'1440': BREAKPOINT_XL,
	'1920': BREAKPOINT_XXL,
};

export function breakPoints(breakAt: BreakPoints): string {
	const breakingPoints: string[] = [];

	/* 0 */
	if (breakAt['0']) breakingPoints.push(`@media (min-width: ${BREAKPOINT_XS}px) {${breakAt['0']}}`);

	/* 375 */
	if (breakAt['375']) breakingPoints.push(`@media (min-width: ${BREAKPOINT_S}px) {${breakAt['375']}}`);

	/* 768 */
	if (breakAt['768']) breakingPoints.push(`@media (min-width: ${BREAKPOINT_M}px) {${breakAt['768']}}`);

	/* 1024 */
	if (breakAt['1024']) breakingPoints.push(`@media (min-width: ${BREAKPOINT_L}px) {${breakAt['1024']}}`);

	/* 1440 */
	if (breakAt['1440']) breakingPoints.push(`@media (min-width: ${BREAKPOINT_XL}px) {${breakAt['1440']}}`);

	/* 1920 */
	if (breakAt['1920']) breakingPoints.push(`@media (min-width: ${BREAKPOINT_XXL}px) {${breakAt['1920']}}`);

	return breakingPoints.join('\n');
}

export function customBreakPoint(breaks: number, style: string): string {
	return `@media (min-width: ${breaks}px) {${style}}`;
}

export function doOnBreakPoint(breakAt: (winWidth: number) => boolean, cb: () => void): void {
	if (breakAt(window?.innerWidth)) cb();
}
